import type { JSX } from 'react';
import { useTranslation } from '../i18n';
import { APP_VERSION } from '../version';

/**
 * Версия и разработчик — одной подписью: спрашивают об этом вместе.
 *
 * Общий компонент, а не две копии: подпись стоит и в оболочке, и на экране
 * входа, и номер фазы, поднятый в одном месте, иначе отстал бы в другом.
 */
export function Signature({ className }: { className?: string }): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={`flex flex-col gap-0.5 ${className ?? ''}`}>
      <div className="font-mono text-xs text-dim">
        {t('nav.version', { version: APP_VERSION, phase: '10' })}
      </div>
      <div className="font-mono text-2xs text-faint">2026. SVSarts</div>
    </div>
  );
}
